import { MarkdownDocs } from '@mui/internal-core-docs/MarkdownDocs';
import * as pageProps from 'docs/data/chat/basics/variants-and-density/variants-and-density.md?muiMarkdown';

export default function Page() {
  return <MarkdownDocs {...pageProps} />;
}
